var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lock_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9af17",
    d: "M512 567.9c-29.3 0-53.1 23.8-53.1 53.1 0 17.1 8.1 32.3 20.6 42v120c0 17.9 14.6 32.5 32.5 32.5s32.5-14.6 32.5-32.5V663c12.5-9.7 20.6-24.9 20.6-42 0-29.3-23.8-53.1-53.1-53.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M878.1 381.4H750.2V241.3c0-63.6-24.8-123.5-69.8-168.5S575.6 3 512 3 388.5 27.8 343.5 72.8s-69.8 104.8-69.8 168.5v140.2H145.9c-17.9 0-32.5 14.6-32.5 32.5v574.5c0 17.9 14.6 32.5 32.5 32.5H878c17.9 0 32.5-14.6 32.5-32.5V659.6c-1.8-16.3-15.6-29-32.4-29-18 0-32.6 14.6-32.6 32.6V956H178.4V446.4H845.5v26.1c0 18 14.6 32.6 32.6 32.6 16.8 0 30.6-12.7 32.4-29V414c.1-18-14.5-32.6-32.4-32.6zM685.2 234.5v146.9H338.8l.4-151.8C344 135.6 425.8 91 425.8 91c92.5-50.6 170-1.3 170-1.3 90.9 52.7 89.4 144.8 89.4 144.8z"
  })));
}

export default SvgLock;